export default "__VITE_ASSET__BjKV2H7L__"